import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/34691204745?text=Hola,%20mi%20nombre%20es%20____.%20Soy%20de%20____.%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20web%20profesional%20por%20297%E2%82%AC%20para%20mi%20negocio.%20Gracias." target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Contactar por WhatsApp" data-id="element-187">
      <motion.div animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      repeatDelay: 3
    }} data-id="element-188">
        <MessageCircleIcon className="w-8 h-8" data-id="element-189" />
      </motion.div>
    </motion.a>;
}